type JobEducationProps = {
  jobData: jobDescriptionType;
};

const JobEducation: React.FC<JobEducationProps> = ({ jobData }) => {
  const qualifications = Array.isArray(jobData?.qualifications)
    ? jobData.qualifications.join(", ")
    : "";
  if (!qualifications) return null;

  return (
    <div className="mt-4 flex flex-col gap-2 px-4 md:!pl-6">
      <label className="text-content-primary text-base font-bold leading-6 md:!text-lg md:!leading-[26px]">
        Education
      </label>
      <p className="text-sm font-normal leading-[22px] md:!leading-6">
        {qualifications}
      </p>
    </div>
  );
};

export default JobEducation;
